import { render, staticRenderFns } from "./cinemaorder.vue?vue&type=template&id=d907aa50&scoped=true&"
import script from "./cinemaorder.vue?vue&type=script&lang=js&"
export * from "./cinemaorder.vue?vue&type=script&lang=js&"
import style0 from "./cinemaorder.vue?vue&type=style&index=0&id=d907aa50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d907aa50",
  null
  
)

export default component.exports